import React from "react";
import { FaChevronRight } from "react-icons/fa6";

const BackgroundImage = (props) => {
    const { selectedLanguage, heading, mainClass } = props
    return (
        <div className={`third-design-banner ${mainClass}`}>
            <div className="third-design-banner-overlay"></div>
            <div className="third-design-banner-text-div">
                <h1>{heading}</h1>
                <h2>
                    {selectedLanguage?.txt_Home}
                    <span><FaChevronRight /></span>
                    {heading}
                </h2>
            </div>
        </div>
    )
}

export default BackgroundImage